(function () {
  function initCrossSell($) {

    /* =========================
       Helpers
    ========================= */
    if (!String.prototype.replaceAll) {
      String.prototype.replaceAll = function (target, replacement) {
        return this.split(target).join(replacement);
      };
    }

    $.fn.inputFilter = function (inputFilter) {
      return this.on(
        "input keydown keyup mousedown mouseup select contextmenu drop",
        function () {
          if (inputFilter(this.value)) {
            this.oldValue = this.value;
            this.oldSelectionStart = this.selectionStart;
            this.oldSelectionEnd = this.selectionEnd;
          } else if (this.hasOwnProperty("oldValue")) {
            this.value = this.oldValue;
            this.setSelectionRange(
              this.oldSelectionStart,
              this.oldSelectionEnd
            );
          } else {
            this.value = "";
          }
        }
      );
    };

    /* =========================
       Cross Sell Object
    ========================= */
    var crossSells = {
      sectionTemp: `<section class="bh-cross-sell">
        [[HEADER]]
        <div class="scroller">
          <div class="scroller__inner">
            <div class="product-list product-list--vertical product-list--scrollable">
              [[PRODUCTS]]
            </div>
          </div>
        </div>
      </section>`,

      headerTemp: `<header class="section__header">
        <h2 class="section__title heading h3">[[HEADING]]</h2>
      </header>`,

      prdTemp: `<div class="product-item product-item--vertical 1/3--lap 1/4--desk 1/4--wide [[STOCK_CLASS]]">
        <a href="[[PRD_URL]]" class="product-item__image-wrapper">
          <div class="aspect-ratio aspect-ratio--square" style="padding-bottom:100%">
            <img class="product-item__primary-image lazyload"
              src="[[PRD_IMG]]"
              alt="[[PRD_TITLE]]" />
          </div>
        </a>

        <div class="product-item__info">
          <div class="product-item__info-inner">
            <a href="[[PRD_URL]]" class="product-item__title text--strong link" style="text-align:center;">
              [[PRD_TITLE]]
            </a>

            <div class="product-item__price-list price-list [[PRD_PRICE_CLASS]]">
              <span class="price">[[PRD_PRICE]]</span>
            </div>

            [[STOCK]]
          </div>

          <div class="atcCont">
            <input type="text" class="qty" value="1" />
            <button type="button"
              class="product-item__action-button button button--small button--primary crossSellItem [[ATC_CLASS]]"
              prd_url="[[PRD_URL]]"
              var_id="[[VARIANT_ID]]">
              [[ATC_TITLE]]
            </button>
          </div>
        </div>
      </div>`,

      inStockTemp:
        '<span class="product-item__inventory inventory inventory--high">In stock</span>',
      outOfStockTemp:
        '<span class="product-item__inventory inventory inventory--low">Out of stock</span>',

      /* =========================
         Render
      ========================= */
      render: function (sections) {
        var html = "";
        for (var key in sections) {
          var section = sections[key];
          html += this.sectionTemp
            .replaceAll("[[HEADER]]", this._getHeader(section))
            .replaceAll("[[PRODUCTS]]", this._getProducts(section));
        }
        $("#crossSellsWrap").html(html);
        this.init();
      },

      _getHeader: function (section) {
        if (!section.title) return "";
        return this.headerTemp.replaceAll("[[HEADING]]", section.title);
      },

      _getProducts: function (section) {
        if (typeof section.data === "string") {
          var products = this._getCollectionProducts(section.data);
          return this._createProductHtml(products || []);
        }
        return this._createProductHtml(section.data);
      },

      _getCollectionProducts: function (handle) {
        var products = [];

        $.ajax({
          url:
            "/collections/" +
            handle +
            "/products.json?limit=12&sort_by=best-selling&_=" +
            Date.now(),
          type: "GET",
          async: false,
          success: function (res) {
            products = res.products || [];
          }
        });

        return products.map(function (item) {
          var variant =
            item.variants.find(function (v) {
              return v.available;
            }) || item.variants[0];

          return {
            title: item.title,
            url: "/products/" + item.handle,
            price: "$" + variant.price,
            image: item.images.length ? item.images[0].src : "",
            available: variant.available,
            defaultVariantId: variant.id,
            variantsCount: item.variants.length,
            hidePrice: $.inArray("Hide Price", item.tags)
          };
        });
      },

      _createProductHtml: function (products) {
        var html = "";
        var self = this;

        products.forEach(function (item) {
          var stock = item.available
            ? self.inStockTemp
            : self.outOfStockTemp;

          var atcTitle = "Add To Cart";
          var atcClass = "csAtc";
          var stockClass = "inStock";

          if (
            !item.available ||
            item.variantsCount > 1 ||
            item.hidePrice !== -1 ||
            parseFloat(item.price.replace("$", "")) === 0
          ) {
            atcTitle = "View";
            atcClass = "";
            stockClass = "";
          }

          var productHtml = self.prdTemp
            .replaceAll("[[PRD_URL]]", item.url)
            .replaceAll("[[PRD_TITLE]]", item.title)
            .replaceAll("[[PRD_IMG]]", item.image)
            .replaceAll("[[VARIANT_ID]]", item.defaultVariantId)
            .replaceAll("[[STOCK]]", stock)
            .replaceAll("[[ATC_TITLE]]", atcTitle)
            .replaceAll("[[ATC_CLASS]]", atcClass)
            .replaceAll("[[STOCK_CLASS]]", stockClass);

          if (item.hidePrice === -1) {
            productHtml = productHtml
              .replaceAll("[[PRD_PRICE]]", item.price)
              .replaceAll("[[PRD_PRICE_CLASS]]", "");
          } else {
            productHtml = productHtml
              .replaceAll("[[PRD_PRICE]]", "")
              .replaceAll("[[PRD_PRICE_CLASS]]", "hide");
          }

          html += productHtml;
        });

        return html;
      },

      init: function () {
        $(document).on(
          "click",
          ".bh-cross-sell .crossSellItem",
          this.addToCart
        );

        $(".bh-cross-sell .qty").inputFilter(function (value) {
          return /^\d*$/.test(value);
        });
      },

      addToCart: function (e) {
        e.preventDefault();

        if (!$(this).hasClass('csAtc')) {
          window.location = $(this).attr('prd_url');
          return false;
        }

        var varId = $(this).attr('var_id');
        var qty = parseInt(
          $(this).closest('.atcCont').find('.qty').val(),
          10
        );

        qty = qty < 1 ? 1 : qty;

        $.ajax({
          type: "POST",
          dataType: "json",
          url: "/cart/add.js",
          async: false, // ⚠️ SAME AS YOUR WORKING CODE
          data: {
            items: [{ quantity: qty, id: varId }]
          },
          success: function () {

            /* 🔥 DRAWER TRIGGER (THE KEY PART) */
            document.dispatchEvent(
              new CustomEvent("theme:loading:start")
            );

            var productSection = document.querySelector(
              'section[data-section-id="product-template"]'
            );

            if (productSection) {
              productSection.dispatchEvent(
                new CustomEvent("product:added", {
                  bubbles: true,
                  detail: {
                    variant: false,
                    quantity: qty
                  }
                })
              );
            }
          },
          error: function (jqXhr) {
            if (
              jqXhr.responseJSON &&
              jqXhr.responseJSON.description
            ) {
              alert(jqXhr.responseJSON.description);
            }
          }
        });
      }
    };

    /* =========================
       INIT
    ========================= */
    if (typeof crossSellSecArr !== "undefined") {
      crossSells.render(crossSellSecArr);
    }
  }

  /* =========================
     jQuery SAFE BOOTSTRAP
  ========================= */
  if (window.jQuery) {
    initCrossSell(jQuery);
  } else {
    document.addEventListener("DOMContentLoaded", function () {
      if (window.jQuery) {
        initCrossSell(jQuery);
      }
    });
  }
})();
